// extracted by mini-css-extract-plugin
module.exports = {"toggleWrapper":"toggle_toggleWrapper__jouuS","selectionText":"toggle_selectionText__1ybey"};